import { Box, NumberInput, NumberInputProps } from '@mantine/core';
import cx from 'clsx';
import { ReactNode } from 'react';

import { useUiLanguage } from 'shared/utils/useUiLanguage';

import classes from './NumberInputPanel.module.scss';
import { ThemeControl } from '../ThemeControl';

type NumberInputPanelProps = {
  label?: string;
  max?: number;
  min?: number;
  numberInputClassName?: string;
  onChange: (newValue: number) => void;
  path?: string;
  resetButton?: ReactNode;
  value: number;
};

export const NumberInputPanel = (props: NumberInputPanelProps) => {
  const { label, path, onChange, value, resetButton, min = 0, max, numberInputClassName } = props;

  const { uiDirection } = useUiLanguage();

  return (
    <ThemeControl label={label} path={path}>
      <Box className={cx(classes.numberInput, numberInputClassName)}>
        <NumberInput
          classNames={{ input: cx(classes.input, uiDirection === 'ltr' ? classes.inputLTR : classes.inputRTL) }}
          value={value}
          onChange={onChange as NumberInputProps['onChange']}
          min={min}
          max={max}
        />
      </Box>
      {resetButton}
    </ThemeControl>
  );
};
